<style>
  .outer {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .inner {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    /*font-family: 'Aktiv Grotesk Corp', 'Arial', sans-serif;*/
    font-family: 'Arial', sans-serif;
    font-size: 20px;

    .covestro-logo {
      width: 10rem;
      height: 10rem;
      margin: 2.5rem 0;
    }

    .message {
      margin-bottom: 1rem;
    }
  }
</style>

<div class="outer">
  <div class="inner">
    <img class="covestro-logo" src="/assets/images/covestro.png" alt="Covestro" />
    <p class="message">We are currently performing planned maintenance. We will be back up soon.</p>
    <p class="message">
      Wir führen derzeit Wartungsarbeiten durch. Das System wird Ihnen in Kürze wieder zur Verfügung
      stehen.
    </p>
    <p class="message">
      Actualmente estamos realizando trabajos de mantenimiento. El sistema estará disponible de
      nuevo en breve.
    </p>
    <p class="message">
      Nous opérons en ce moment des travaux d‘entretien. Le système vous sera mis de nouveau à
      disposition dès que possible.
    </p>
    <p class="message">
      Stiamo effettuando una manutenzione programmata. Il sito sarà nuovamente disponibile a breve.
    </p>
    <p class="message">
      現在、メンテナンス中となっております。すぐに、通常の状態に戻る予定です。御迷惑をお掛け致します。
    </p>
    <p class="message">
      현재 사이트 유지 보수 작업 중입니다. 곧 정상 복구 예정이니 양해 부탁드립니다.
    </p>
    <p class="message">Estamos realizando uma manutenção planejada. Estaremos de volta em breve.</p>
    <p class="message">
      В настоящее время мы проводим техническое обслуживание. Система будет снова доступна в
      ближайшее время.
    </p>
    <p class="message">
      ขณะนี้ทางบริษัทกำลังดำเนินการปิดปรับปรุงระบบเว็บไซต์ชั่วคราวและจะสามารถกลับมาใช้งานใหม่ได้อีกครั้งในเร็วๆนี้ขออภัยในความไม่สะดวกมา
      ณ ที่นี
    </p>
    <p class="message">
      Chúng tôi hiện đang thực hiện bảo trì theo kế hoạch. Tất cả sẽ sớm hoạt động trở lại, xin lỗi
      Quý khách nếu có bất kỳ bất tiện gì.
    </p>
    <p class="message">系統正在維護中，我們將盡速恢復各項服務，造成不便請見諒。</p>
    <p class="message">我们正在进行计划内的系统维护，我们将很快回来。</p>
    <p class="message">
      Şu anda bakım çalışmalarını yürütüyoruz. Sistem kısa süre içinde tekrar kullanımınıza
      sunulacaktır.
    </p>
    <p class="message">
      Obecnie prowadzimy prace konserwacyjne. System zostanie wkrótce ponownie udostępniony.
    </p>
    <p class="message">
      Momentalne mame systemovou údržbu. System bude v brzke dobe opet k dispozici.
    </p>
  </div>
</div>
